import { useQuery } from 'apollo-3';

import { getMPMyGoals } from 'GraphQL/query/MyPath.query';

const useMPMyGoals = (props) => {
  const { ...restProps } = props;
  const { data, loading, error, refetch } = useQuery(getMPMyGoals, {
    ...restProps,
  });

  return {
    data: data?.mpMyGoals,
    loading,
    error,
    refetch,
  };
};

export default useMPMyGoals;
